import React from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { EditableRichText } from 'shared'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './DescriptionSection.style'

const DescriptionSection = ({ altMode }) => {
  const { championship } = useSelector((state) => state.championships)

  const classes = useStyles()

  return (
    <SectionBlock title='Descripción' className={clsx(altMode && classes.altSection)}>
      <EditableRichText
        entity={championship}
        field='description'
        activeModeEdit={false}
        inputClassName={classes.textAreaEdit}
        repositoryId={championship.id}
      />
    </SectionBlock>
  )
}

export default DescriptionSection
